<template>
  <!--
      作者 kmdshop
      时间：2020-9-25
      描述：设置-证书设置
  -->
  <div>
    <!--form表单-->
    <el-form size="small" ref="formData" :model="formData" label-width="150px">
      <!--证书设置-->
      <div class="common-form">证书设置</div>
      <el-form-item label="是否开启授权证书" prop="is_open_cert"><el-switch v-model="formData.is_open_cert"></el-switch></el-form-item>

      <el-form-item label="证件背景图片:" :rules="[{ required: true, message: '请上传证件背景图片' }]" >
        <div class="draggable-list">
          <draggable class="wrapper" v-model="formData.image">
            <transition-group>
              <div class="item" v-for="(item,index) in formData.image" :key="item">
                <img v-img-url="item" />
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </transition-group>
          </draggable>
        </div>
        <el-button @click="chooseImg" style="margin: 10px;">选择图片</el-button>
      </el-form-item>

      <!-- <el-form-item label="证件背景图片" :rules="[{required: true,message: '请上传证件背景图片'}]">
        <el-button @click="chooseImg">选择图片</el-button>
        <div v-for="(item,index) in formData.image" :key="item.file_path">
          <img v-img-url="item.file_path" class="mt10" width="200"/>
          <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
        </div>
      </el-form-item> -->

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
      </div>
    </el-form>

     <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 5 }" @returnImgs="returnImgsFunc"></Upload>

  </div>
</template>

<script>
  import PlusApi from '@/api/plus.js';
  import Upload from '@/components/file/Upload';
  import draggable from 'vuedraggable';
  export default{
    components:{
      Upload,
      draggable
    },
    data(){
      return {
        /*是否正在加载*/
        loading:true,
        /*表单数据对象*/
        formData:{
          is_open_cert:false,
          image:[],
        },
        /*是否打开图片选择*/
        isupload:false,
      }
    },
    created() {
      this.getParams();
    },
    methods:{

      /*获取配置数据*/
      getParams() {
        let self = this;
        PlusApi.getCertConfig({}, true).then(res => {

            if (res.code == 1) {
              self.formData.is_open_cert=res.data.vars.is_open_cert;
              self.formData.image=res.data.vars.image;
              self.loading=false;
            } 
          })
          .catch(error => {

          });
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.formData;
        self.$refs.formData.validate((valid) => {
          if (valid) {
            self.loading = true;
            PlusApi.setCertificate(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你， 授权证书设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },

      /*选择图片*/
      chooseImg(){
        this.isupload=true;
      },
      /*删除商品图片*/
      deleteImg(index) {
        this.formData.image.splice(index, 1);
      },
      /*关闭选择图片*/
      returnImgsFunc(e){
        if (e != null) {
          let imgs = this.formData.image.concat(e);
          this.$set(this.formData, 'image', imgs);
        }
        console.log(this.formData.image)
        this.isupload=false;
        // this.formData.image=e[0].file_path;
      },
    }
  }
</script>

<style>
  
  .draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .draggable-list .wrapper > span {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
    }

    .draggable-list .item {
      position: relative;
      width: 300px;
      height: 300px;
      margin-top: 10px;
      margin-right: 10px;
      border-radius: 8px;
      overflow: hidden;
      border: 1px solid #dddddd;
    }

    .draggable-list .delete-btn {
      position: absolute;
      top: 0;
      right: 0;
      width: 16px;
      height: 16px;
      background: red;
      line-height: 16px;
      font-size: 16px;
      color: #ffffff;
      display: none;
    }

    .draggable-list .item:hover .delete-btn {
      display: block;
    }

    .draggable-list .item img {
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      max-height: 100%;
      max-width: 100%;
    }

    .draggable-list .img-select {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #dddddd;
      font-size: 30px;
    }

    .draggable-list .img-select i {
      color: #409eff;
    }

</style>



// WEBPACK FOOTER //
// src/views/plus/certificate/setting/Setting.vue